// extracted by mini-css-extract-plugin
export default {"ViewSkyX":"ViewModeLabel_ViewSkyX__+RFtK"};